import { h, insert, addTranslations, addToHead } from '@jsx6/jsx6'
import { addScript } from './addScript.js'
import { initScreenType } from './initScreenType.js'
import { ChatBox } from './ChatBox.js'

const localUrl = path => new URL(path, import.meta.url)
const fontFolder = localUrl('./fonts')

const ICON_CSS = `@font-face {
  font-family: 'nexios';
  src: 
    url('${fontFolder}/nexios.ttf?egbslz') format('truetype'),
    url('${fontFolder}/nexios.woff?egbslz') format('woff'),
    url('${fontFolder}/nexios.svg?egbslz#nexios') format('svg');

  font-weight: normal;
  font-style: normal;
}
`

const FONT_CSS = 'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap'

// @type {import("./ChatOptions.js").ChatOptions}
const defaults = {
  startup: 'buttons',
  userMode: 'chat',
  contactDataForm: true,
  deviceSelectionForm: true,
  formData: {},
  css: 'chat.default.css',
  iconCss: ICON_CSS,
  fontCss: FONT_CSS,
  elementId: '',
  chatButtons: ['text'],
}

function addCss(css){
  addToHead(
    /^(http|\.\/|\/)/.test(css) ? (
      <link rel="stylesheet" href={localUrl(css)}></link>
    ) : (
      <style>{css}</style>
    ),
  )
}

/**
 *
 * @param {Object} TRANS
 * @param {Element} parentFrame
 * @param {Window} parentWindow
 * @param {import("./ChatOptions.js").ChatOptions} options
 * @returns {Promise<ChatBox>} chat
 */
export const runChatBox = async (TRANS, parentFrame, parentWindow, options) => {
  if (!TRANS) {
    TRANS = (await import('./lang/' + options.lang + '.js')).default
  }

  const orgIdStr = options.idInit?.split('-')?.[0]
  // TODO prepared for customTranslations... remove try/catch block when ready and configured for orgId 99
  let custom = options.customTranslations || {}
  try {
    if (!Object.keys(custom).length) {
      const orgId = typeof orgIdStr === 'string' ? parseInt(orgIdStr) : orgIdStr
      const customTranslateOrgIds = [ 8, 99 ]

      if (customTranslateOrgIds.indexOf(orgId) !== -1) {
        const filePath = `./lang/custom.js`
        custom = (await import(filePath)).default?.[ `org${orgIdStr}` ]?.[ options.lang ] || {}
      }
    }
  } catch (error) {
    console.error(`Cannot fetch custom file: ${error}`)
  }

  TRANS = {...TRANS, ...custom}

  if(!options.userMode && options.chatType) options.userMode = options.chatType
  options = { ...defaults, ...options }

  let { css, elementId } = options
  if(!css ) css = defaults.css
  const cssFile = await fetch(localUrl(css)).then(r => r.text())
  let el = elementId
    ? document.getElementById(elementId)
    : insert(document.body, <div id="NexiosChat" style="position:fixed; bottom: 20px; right: 20px; z-index: 9999;" />)
  let root = el.attachShadow({ mode: 'open' })
  root.innerHTML = `<div></div><style>${cssFile}</style>`
  const body = root.firstChild
  globalThis.activateJsxInspector?.(root)
  let screenType = initScreenType(body)
  addCss(options.fontCss || defaults.fontCss)
  addCss(options.iconCss || defaults.iconCss)
  addToHead(<link rel="stylesheet" href="https://etrust-sandbox.electronicid.eu/js/videoid-3.x/assets/css/colors.css" />)
  addToHead(<link rel="stylesheet" href="https://etrust-sandbox.electronicid.eu/js/videoid-3.x/assets/css/primitives.css" />)
  addToHead(<link rel="stylesheet" href="https://etrust-sandbox.electronicid.eu/js/videoid-3.x/assets/css/detection.css" />)
  addToHead(<style>{`.video-scan { position: fixed !important; top: 0; left: 0; width: 100%; height: 100%; background: white; }`}</style>)
  addTranslations(TRANS)
  let chat = new ChatBox(body, parentWindow, parentFrame, screenType)
  addTranslations(TRANS)
  addScript(document, localUrl('/sip-0.21.2.min.js'), function () {
    insert(body, chat)
    if(options.mode) body.setAttribute('mode', options.mode)
    // console.log(options.mode, body)
    chat.initChat(options)
    parentWindow.NexiosChatBox = chat
    parentWindow.NexiosChat = chat
    if (options.isPreview) parentWindow.setPreviewReady()
    if (screenType.Mobile) {
      body.setAttribute('class', 'mobileBody')
    }
    chat.resize()
  })
  
  return chat
}